import React from "react";
import { Heading, SmallBody } from "src/components";
import "./UberContentHighlightedText.scss";

export interface IHighlightedTextContent {
    text: string;
    sender: string;
}

export const parseHighlightedTextContent = (content: string): IHighlightedTextContent => {
    if (content) {
        try {
            const parsed = JSON.parse(content);

            return {
                text: parsed.text ?? "",
                sender: parsed.sender ?? "",
            };
        } catch {
        }
    }

    return {
        text: "",
        sender: "",
    };
};

const UberContentHighlightedText = (props: IHighlightedTextContent) => (
    <div className="UberContentHighlightedText">
        <Heading as="div" color="contentDark" className="UberContentHighlightedText-text">
            {props.text}
        </Heading>
        {!!props.sender?.trim() && (
            <SmallBody as="div" color="contentLight" className="UberContentHighlightedText-sender">
                {props.sender}
            </SmallBody>
        )}
    </div>
);

export default UberContentHighlightedText;
